import PropTypes from 'prop-types';
import { useCallback, useMemo, useState } from 'preact/hooks';

RangePicker.propTypes = {
  items: PropTypes.arrayOf(PropTypes.shape({value: PropTypes.any, name: PropTypes.string})).isRequired,
  currentValue: PropTypes.any.isRequired,
  onChange: PropTypes.func,
  fieldName: PropTypes.string.isRequired,
  labelText: PropTypes.string,
  disabled: PropTypes.bool,
}
export default function RangePicker({items, currentValue, onChange, fieldName, labelText, disabled = false}) {
  const getStepKey = useCallback((item) => {
    return `step-${item.value}`;
  }, []);

  const [value, setValue] = useState(currentValue);

  const currentValueIndex = useMemo(() => {
    const item = items.find(i => i.value === value);

    if (item) {
      return items.indexOf(item);
    }

    return 0;
  }, [value, items])

  const setCurrentValue = useCallback((event) => {
    const item = items[event.target.valueAsNumber];
    if (item) {
      setValue(prevState => {
        if (prevState !== item.value) {
          onChange({
            target: {
              value: item.value,
              name: event.target.name
            }
          });
          return item.value;
        }

        return prevState;
      });
    }
  }, [items, onChange]);

  return (
    <fieldset className="fieldset w-full">
      {labelText && <legend className="fieldset-legend">{labelText}</legend>}
      <input disabled={disabled} onChange={setCurrentValue} type="range" min={0} max={items.length - 1} value={currentValueIndex} name={fieldName} className="w-full range range-secondary" step="1" />
      <div className="flex justify-between px-2.5 mt-2 text-xs">
        {items.map((item) => <span key={getStepKey(item)}>|</span>)}
      </div>
      <div className="flex justify-between px-2.5 mt-2 text-xs">
        {items.map((item) => <span key={getStepKey(item)}>{item.name}</span>)}
      </div>
    </fieldset>
  )
}